<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="42" height="37" viewBox="0 0 42 37">
    <defs>
      <filter id="82447n6lsa" width="112%" height="112%" x="-6%" y="-3%" filterUnits="objectBoundingBox">
        <feOffset dy="3" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="1.5" />
        <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0.0666666667 0 0 0 0 0.28627451 0 0 0 0 0.501960784 0 0 0 0.0338723776 0" />
      </filter>
      <circle id="rjcfvrby4b" cx="50" cy="50" r="50" />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <g>
        <path fill="#F6F6F7" d="M0 0H1440V1050H0z" transform="translate(-699 -627)" />
        <g>
          <g transform="translate(-699 -627) translate(670 595)">
            <use fill="#000" filter="url(#82447n6lsa)" xlink:href="#rjcfvrby4b" />
            <use fill="#FFF" xlink:href="#rjcfvrby4b" />
          </g>
          <path
            fill="#B2BFD8"
            d="M21 0c.701 0 1.342.394 1.658 1.019L41.8 34.025c.292.577.264 1.263-.074 1.814-.338.55-.938.885-1.584.885H1.86c-.646 0-1.246-.335-1.584-.885-.338-.551-.366-1.237-.074-1.814L19.34 1.019C19.659.394 20.3 0 21 0zm0 5.972L4.886 33.006h32.229L21 5.972zm.224 21.062c.119.03.238.06.35.111.111.045.215.105.319.171.104.067.194.14.283.23.081.083.163.179.23.283.067.097.127.208.172.32.044.111.082.23.103.35.023.119.038.238.038.357 0 .49-.2.973-.543 1.316-.342.35-.826.543-1.317.543-.118 0-.245-.008-.364-.03-.12-.03-.238-.06-.35-.112-.111-.044-.215-.103-.32-.17-.096-.068-.193-.142-.282-.231-.082-.082-.163-.179-.23-.283-.067-.097-.126-.208-.171-.32-.045-.11-.082-.23-.105-.349-.022-.119-.037-.238-.037-.364 0-.12.015-.238.037-.357.023-.12.06-.239.105-.35.045-.112.104-.223.17-.32.068-.104.15-.2.231-.282.09-.09.186-.164.283-.23.104-.067.208-.127.32-.172.119-.051.23-.082.35-.111.237-.045.49-.045.728 0zM20.86 13c1.021 0 1.86.832 1.86 1.86v9.199c0 1.027-.839 1.86-1.86 1.86-1.021 0-1.86-.833-1.86-1.86v-9.2c0-1.027.839-1.859 1.86-1.859z"
            transform="translate(-699 -627) translate(670 595) translate(29 32)"
          />
        </g>
      </g>
    </g>
  </svg>
</template>